import React, {useState} from 'react';
import {Trans} from 'gatsby-plugin-react-i18next';
import {Integrations} from '../links/Integrations';
import {MenuItem, LinkWrapper, TriangleArrow, DropdownMenu} from '../utils/Styled';

export const IntegrationsSelector: React.FC = () => {
  const [isOpen, setOpen] = useState(false);

  return (
    <MenuItem onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <LinkWrapper>
        <Trans>Integrations</Trans>
      </LinkWrapper>
      <DropdownMenu visible={isOpen} minWidth="330px" left="-125px" leftMobile="-105px" column>
        <TriangleArrow visible={isOpen} left="calc(40% - 24px)" />
        <Integrations itemClick={() => setOpen(false)} />
      </DropdownMenu>
    </MenuItem>
  );
};
